module.exports = __webpack_public_path__ + "img/4004f4f.jpg";